// src/routes/modules/godownRoutes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import MasterLayout from '../../masterLayout/MasterLayout';

import ViewGodowns from '../../pages/Godown/ViewGodowns';
import AddGodown   from '../../pages/Godown/AddGodown';
import ViewGodown  from '../../pages/Godown/ViewGodown';
import EditGodown  from '../../pages/Godown/EditGodown';
import PaymentsPage from '../../pages/Orders/PaymentsPage';
import GodownDashboard from '../../pages/Godown/GodownDashboard'
 
import MyGodowns from '../../pages/Godown/MyGodowns';
import ViewGodownEmployees from '../../pages/Team/ViewGodownEmployees';;
 

const godownRoutes = (
  <>
    {/* Admin / management */}
    <Route path="/godown/view"      element={<ProtectedRoute><MasterLayout><ViewGodowns /></MasterLayout></ProtectedRoute>} />
    <Route path="/godown/view/:id"  element={<ProtectedRoute><MasterLayout><ViewGodown /></MasterLayout></ProtectedRoute>} />
    <Route path="/godown/add"       element={<ProtectedRoute><MasterLayout><AddGodown /></MasterLayout></ProtectedRoute>} />
    <Route path="/godown/edit/:id"  element={<ProtectedRoute><MasterLayout><EditGodown /></MasterLayout></ProtectedRoute>} />

    {/* Godown Manager operational view */}
    <Route path="/godown/dashboard" element={<ProtectedRoute><MasterLayout><GodownDashboard /></MasterLayout></ProtectedRoute>} />
    <Route path="/godown/my-godowns"        element={<ProtectedRoute><MasterLayout><MyGodowns /></MasterLayout></ProtectedRoute>} />
    <Route path="/team/godown-employees"    element={<ProtectedRoute><MasterLayout><ViewGodownEmployees /></MasterLayout></ProtectedRoute>} />
  </>
);

export default godownRoutes;